import { Container, Link, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import PageTitle from "../../components/Common/PageTitle";
import contactInfo from "../../data/contactInfo.json";
import { cardContainer, emailLink } from "../../styles/commonStyles";

const ContactPage = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Container maxWidth="md" sx={cardContainer(theme)}>
      <PageTitle text={t("contact")} />
      <Stack spacing={4} sx={{ mt: theme.spacing(3) }}>
        <Stack spacing={1}>
          <Typography variant="h6">{contactInfo.companyName}</Typography>
          <Typography variant="body2" color="text.secondary">
            {t("regNumber")}: {contactInfo.registrationNumber}
          </Typography>

          <Stack direction="row" spacing={2} alignItems="center">
            <Typography variant="body1" sx={{ fontFamily: theme.typography.fontFamily }}>
              <Link href={`mailto:${contactInfo.email}`} underline="hover" color="primary" sx={emailLink}>
                {contactInfo.email}
              </Link>
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Container>
  );
};

export default ContactPage;
